import styled from 'styled-components';
import React from 'react';
import { Checkbox, Heading } from '@alefeducation/ui-elements-library-core';
import RolesSidebar from './RolesSidebar';
import { Role } from './roles.types';
import { getRoleListWidth } from './roles.styled';
import { useRolesContext } from './context/RolesContext';

const StyledRoleSelectionBody = styled.div`
  display: flex;
  background-color: white;
  height: calc(100% - 62px);
  border-radius: 8px;
  box-shadow: 0 22px 54px -20px rgba(72, 84, 101, 0.4);
`;

const StyledRoleList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 26px;
  row-gap: 20px;
  overflow-y: auto;

  ${getRoleListWidth};
`;

const StyledCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space[8]}px;
`;

const StyledRoleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledHeading = styled(Heading)`
  margin-left: 36px;
`;

const RolesSelectionBody = () => {
  const { onToggleSelectedRole, organisation, roles } = useRolesContext();
  const hasRoles = roles.length > 0;

  const renderNoRolesView = () => <div>No roles for selected category</div>;

  const onChange = (role: Role) => {
    onToggleSelectedRole({
      id: role.id,
      name: role.title,
      org: organisation.code,
    });
  };

  const renderRoles = () =>
    roles.map((role, i) => (
      <StyledRoleContainer key={i} id={role.title.replace(' ', '')}>
        <StyledCheckboxContainer>
          <Checkbox
            value={role.title}
            variant="default"
            checked={role.checked}
            aria-label={role.title}
            onChange={() => onChange(role)}
          >
            <Heading variant="heading-small">{role.title}</Heading>
          </Checkbox>
        </StyledCheckboxContainer>
        <StyledHeading
          variant="heading-small"
          color="primary.100"
          weight="light"
        >
          {role.description}
        </StyledHeading>
      </StyledRoleContainer>
    ));

  return (
    <StyledRoleSelectionBody>
      <RolesSidebar />
      <StyledRoleList>
        {hasRoles ? renderRoles() : renderNoRolesView()}
      </StyledRoleList>
    </StyledRoleSelectionBody>
  );
};

export default RolesSelectionBody;
